(() => {
  const cartUrl = window.routes?.cart_url || '/cart';
  const rootUrl = window.routes?.root_url || '/';
  const convocationPath = '/collections/mcgill-convocation-flowers';

  const clean = (path) => String(path || '/').replace(/\/+$/, '') || '/';
  const isCart = () => clean(window.location.pathname) === clean(new URL(cartUrl, window.location.origin).pathname);
  const isConvocationPage = () =>
    clean(window.location.pathname) === clean(convocationPath) ||
    !!document.querySelector('select[name="properties[Convocation Date]"], select[name="properties[Convocation Time]"]');

  const targetWithPreview = (path) => {
    const url = new URL(path, window.location.origin);
    const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    return `${url.pathname}${url.search}`;
  };

  const homeTarget = () => targetWithPreview(rootUrl);
  const convocationTarget = () => targetWithPreview(convocationPath);

  const isHomeLink = (link) => {
    if (!link?.getAttribute) return false;
    const href = link.getAttribute('href');
    if (!href) return false;
    try {
      const url = new URL(href, window.location.origin);
      return url.origin === window.location.origin && clean(url.pathname) === clean(new URL(rootUrl, window.location.origin).pathname);
    } catch (error) {
      return false;
    }
  };

  const isCartHomeLink = (link) =>
    isCart() && !!link?.closest?.('cart-items .title-wrapper, cart-items .cart__warnings');

  const applyCartHome = () => {
    if (!isCart()) return;
    document.querySelectorAll('cart-items .title-wrapper a[href], cart-items .cart__warnings a[href]').forEach((link) => {
      link.setAttribute('href', homeTarget());
    });
  };

  const applyConvocationShell = () => {
    if (!isConvocationPage()) return;

    if (!document.getElementById('mcgill-convocation-shell-style')) {
      const style = document.createElement('style');
      style.id = 'mcgill-convocation-shell-style';
      style.textContent = '.header__inline-menu,.header__menu,.header__icon--menu,.header__icon--search,mobile-dock .dock__item[data-action="menu"],mobile-dock .dock__item[data-action="search"]{display:none!important;}';
      document.head.appendChild(style);
    }

    document.querySelectorAll('a[href]').forEach((link) => {
      if (!isHomeLink(link)) return;
      link.setAttribute('href', convocationTarget());
      const label = link.closest('mobile-dock')?.querySelector('span');
      if (label && label.textContent.trim().toLowerCase() === 'home') label.textContent = 'Convocation';
    });
  };

  if (window.shopSettings) window.shopSettings.cartDrawer = false;

  document.addEventListener('click', (event) => {
    const link = event.target?.closest?.('a[href]');

    if (link && isCartHomeLink(link)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(homeTarget());
      return;
    }

    if (link && isConvocationPage() && isHomeLink(link)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(convocationTarget());
      return;
    }

    const cartTrigger = event.target?.closest?.('cart-drawer summary, .dock__item[data-action="cart"]');
    if (cartTrigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(cartUrl);
    }
  }, true);

  const prepare = () => {
    document.querySelectorAll('.dock__item[data-action="cart"]').forEach((el) => {
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
    });
    document.querySelectorAll('cart-drawer details[open]').forEach((details) => details.removeAttribute('open'));
    applyCartHome();
    applyConvocationShell();

    if (isCart()) {
      let timer;
      const observer = new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(applyCartHome, 50);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  document.addEventListener('keydown', (event) => {
    const cartTrigger = event.target?.closest?.('.dock__item[data-action="cart"]');
    if (!cartTrigger || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(cartUrl);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
  else prepare();
})();
